import { bannerManager, Site } from '@envato/foundation-types'
import { connect, Dispatch } from 'react-redux'
import { matchRoutes } from 'react-router-config'

import { openModal } from '../../common/actions/layout'
import { getUserProfile } from '../../common/actions/user/'
import { getSessionSuccessAction } from '../../common/actions/user/session'
import { IRootState } from '../../common/reducers'
import { IEnhancedLocation } from '../../common/reducers/reactRouterLocation'
import { hasFeature } from '../../common/utils/features'
import makeSearchLink from '../../common/utils/location/makeSearchLink'
import { IQuery, MakeSearchLink } from '../../common/utils/location/types'
import { makeLink } from '../../common/utils/urlHelper'
import { ITopMenuItem } from '../../config/sites/menus/types'
import { IRouteConfig } from '../../typings/routes'
import SiteHeader from '../components/siteHeader/siteHeader'

interface IStateProps {
  banners: bannerManager.headerBanners.IResult
  currentSite: Site
  menuConfig: ITopMenuItem[]
  location: IEnhancedLocation
  searchBar: boolean
  experiments: any
  makeSearchLink: MakeSearchLink
}

interface IOwnProps {
  routes: IRouteConfig[]
}

interface IDispatchProps {
  handleSignInSuccess: (token: string) => any
  openModal: (data: any) => any
}

const displaySearchBarByRoutes = (
  routes: IRouteConfig[],
  pathname: string
): boolean => {
  const matchedRouter = matchRoutes<IQuery>(routes, pathname)
  return !!(matchedRouter[matchedRouter.length - 1].route as IRouteConfig)
    .searchBar
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const { common, marketing, router, experiments } = state
  const { currentSite, menuConfig } = common
  const { banners } = marketing
  const { location } = router
  const { routes } = ownProps

  const newRoutesEnabled = hasFeature(
    'routes:new',
    currentSite,
    location,
    experiments
  )

  const searchBar = displaySearchBarByRoutes(routes, location.pathname)

  return {
    banners,
    currentSite,
    menuConfig,
    location,
    searchBar,
    experiments,
    makeSearchLink: newRoutesEnabled ? makeSearchLink : makeLink
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>): IDispatchProps => {
  return {
    handleSignInSuccess: (token: string) => {
      dispatch(getSessionSuccessAction(token))
      return dispatch(getUserProfile(token) as any)
    },
    openModal: (data: any) => dispatch(openModal(data))
  }
}

export type Props = IStateProps & IDispatchProps

const SiteHeaderContainer = connect<
  IStateProps,
  IDispatchProps,
  any,
  IRootState
>(
  mapStateToProps,
  mapDispatchToProps
)(SiteHeader)

export default SiteHeaderContainer
